import React from 'react';
import 'react-modal-video/scss/modal-video.scss';
import ContactModal from "../ContactModal";

function Main1() {
    return (
            <section className="about-section-two style-two layout-pt-100 layout-pb-60 js-tab-menu-content page-lahalle" style={{position: 'relative', overflow: 'visible'}}>
                <div className="auto-container">
                    <div className="row grid-base align-items-center">

                        <div className="content-column -no-margin col-xl-5 offset-xl-2 col-lg-5 offset-lg-1 col-md-12 col-sm-12">
                            <div className="wow fadeInLeft">
                                <div className="sec-title raleway">
                                    <h2 className="fw-700">Qui peut en <span>bénéficier ?</span></h2>
                                </div>
                                <div className="text nunito">
                                    <b>Toute personne salariée d’Incluvia</b> (personne concernée, manager, aidant...) qui a
                                    des questions sur le handicap ou sur les maladies chroniques tels que diabète,
                                    problèmes respiratoires, douleurs, hypertension artérielle, cancer même après guérison...
                                </div>

                                {/*<motion.button
                                        className="theme-btn btn-style-one small"
                                        initial={{opacity: 0, y: 0}}
                                        animate={{opacity: 1, y: 20}}
                                        transition={{delay: 1.0, duration: 1.5}}
                                        data-cal-namespace="ligne-inclusion"
                                        data-cal-link="team/talents-handicap/ligne-inclusion"
                                        data-cal-config='{"layout":"month_view"}'
                                >Réserver un créneau
                                </motion.button>*/}

                                <ContactModal
                                    textButton="Réserver mon RDV"
                                    showText={false}
                                    small="small"
                                    linkPageContact={false}
                                    iframe={true}
                                    couleur={false}
                                    page="incluvia"
                                />
                            </div>
                        </div>
                        <div className="image-column col-xl-5 col-lg-6 col-md-12 col-sm-12 wow fadeInRight">
                            <figure className="image-box image-responsive">
                                <img src="/images/lahalle/femme-hotine2.webp" alt="Qui peut en bénéficier"
                                     style={{position: 'absolute', maxWidth: '130%', bottom: '-180px', right: '-120px'}}/>
                            </figure>
                        </div>
                    </div>
                </div>
            </section>
    );
}

export default Main1;
